export default __webpack_public_path__ + "static/media/greyCall.75b6c487.svg";